module.exports = __webpack_public_path__ + "img/BNL_DM.bf34d6b4.png";